<template>
    <router-link :to="to" class="text-sky-600 hover:text-sky-900">
        <slot>
            {{ text }}
        </slot>
    </router-link>
</template>

<script setup>
defineOptions({
    name: 'ZenGridBodyCellPrimaryLink',
})

defineProps({
    text: {
        type: String,
        required: false,
    },
    to: {
        type: Object,
        required: true,
    },
})
</script>
